export default __webpack_public_path__ + "static/media/Markers_Grey Marker.e88fd32c.svg";